
class Performance {
  getBrowserTimingStats(performance) {
    let stats;
    
    if (performance) {
      const {timing} = performance;
      
      stats = {
        navigation_time: timing.loadEventEnd - timing.navigationStart,
        redirect_time: timing.redirectEnd - timing.redirectStart,
        cache_time: timing.domainLookupStart - timing.fetchStart,
        dns_time: timing.domainLookupEnd - timing.domainLookupStart,
        connection_time: timing.connectEnd - timing.connectStart,
        backend_load_time: timing.responseEnd - timing.requestStart,
        dom_interactive_time: timing.domInteractive - timing.navigationStart,
        dom_parsing_time: timing.domInteractive - timing.domLoading,
        dom_ready_time: timing.domComplete - timing.domInteractive,
        frontend_load_time: timing.loadEventEnd - timing.domInteractive,
        load_event_time: timing.loadEventEnd - timing.loadEventStart,
      };
      
      // Time to first paint
      if (timing.firstPaint === undefined) {
        // Chrome
        if (window.chrome && window.chrome.loadTimes) {
          timing.firstPaint = window.chrome.loadTimes().firstPaintTime * 1000;
        }
        // IE
        else if (typeof timing.msFirstPaint === 'number') {
          timing.firstPaint = timing.msFirstPaint;
        }
      }
      // Add first paint to stats
      if (timing.firstPaint) {
        stats.first_paint_time = Math.round(timing.firstPaint - timing.navigationStart);
      }
    }
    return stats;
  }
  
  getPerformanceStats(performance) {
    const timingData = {};
    const timing = this.getBrowserTimingStats(performance);
    if (timing) {
      timingData.timing = timing;
    }
    return timingData;
  }
}

export default new Performance();
